function initGalleries(root = document) {
  root.querySelectorAll('[data-styloria-gallery]').forEach((gal) => {
    if (gal.dataset.galleryReady === '1') return;
    gal.dataset.galleryReady = '1';

    const track = gal.querySelector('[data-gallery-track]');
    const slides = Array.from(gal.querySelectorAll('[data-slide]'));
    const dots = Array.from(gal.querySelectorAll('[data-gallery-dot]'));
    const prev = gal.querySelector('[data-gallery-prev]');
    const next = gal.querySelector('[data-gallery-next]');
    if (!track || slides.length === 0) return;

    let index = 0;
    let startX = 0;
    let deltaX = 0;
    let dragging = false;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.galleryDot) || 0));
    });

    const onStart = (x) => {
      dragging = true;
      startX = x;
      deltaX = 0;
      track.style.transition = 'none';
    };
    const onMove = (x) => {
      if (!dragging) return;
      deltaX = x - startX;
      const pct = (deltaX / track.clientWidth) * 100;
      track.style.transform = `translateX(calc(-${index * 100}% + ${pct}%))`;
    };
    const onEnd = () => {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (Math.abs(deltaX) > track.clientWidth * 0.2) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      } else {
        goTo(index);
      }
    };

    track.addEventListener('touchstart', (e) => onStart(e.touches[0].clientX), { passive: true });
    track.addEventListener('touchmove', (e) => onMove(e.touches[0].clientX), { passive: true });
    track.addEventListener('touchend', onEnd);
    track.addEventListener('mousedown', (e) => {
      e.preventDefault();
      onStart(e.clientX);
    });
    window.addEventListener('mousemove', (e) => onMove(e.clientX));
    window.addEventListener('mouseup', onEnd);

    goTo(0);
  });
}

function ensureShareToast() {
  let toast = document.getElementById('StyloriaShareToast');
  if (toast) return toast;
  toast = document.createElement('div');
  toast.id = 'StyloriaShareToast';
  toast.className = 'styloria-share-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  document.body.appendChild(toast);
  return toast;
}

function showShareToast(message) {
  const toast = ensureShareToast();
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(showShareToast._timer);
  showShareToast._timer = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 1800);
}

async function copyShareUrl(url) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return;
  }
  const input = document.createElement('input');
  input.value = url;
  input.setAttribute('readonly', '');
  input.style.position = 'fixed';
  input.style.opacity = '0';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  input.remove();
}

async function shareProduct({ url, title }) {
  if (typeof navigator.share === 'function') {
    try {
      await navigator.share({ url, title, text: title });
      return 'shared';
    } catch (err) {
      if (err && err.name === 'AbortError') return 'cancelled';
    }
  }
  await copyShareUrl(url);
  return 'copied';
}

function markShareCopied(btn) {
  btn.classList.add('is-copied');
  const prev = btn.getAttribute('aria-label');
  btn.setAttribute('aria-label', 'Link copied');
  showShareToast('Link copied');
  clearTimeout(btn._shareTimer);
  btn._shareTimer = setTimeout(() => {
    btn.classList.remove('is-copied');
    btn.setAttribute('aria-label', prev || 'Share');
  }, 1800);
}

function initShareButtons(root = document) {
  root.querySelectorAll('[data-styloria-share]').forEach((btn) => {
    if (btn.dataset.shareReady === '1') return;
    btn.dataset.shareReady = '1';
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const url = btn.dataset.shareUrl || window.location.href;
      const title = btn.dataset.shareTitle || document.title;
      try {
        const result = await shareProduct({ url, title });
        if (result === 'copied') markShareCopied(btn);
      } catch (_) {
        window.prompt('Copy link', url);
      }
    });
  });
}

function initPdpShareButtons(root = document) {
  root.querySelectorAll('[data-styloria-share-pdp]').forEach((el) => {
    if (el.dataset.shareReady === '1') return;
    el.dataset.shareReady = '1';

    const host = el.closest('share-button') || el.closest('.share-button');
    const input = host?.querySelector('input[type="text"], .field__input');
    const url = input?.value || window.location.href;
    const title = document.title;

    // Prefer a plain button click over Dawn details/summary fallback UI.
    const details = el.closest('details');
    if (details) {
      details.addEventListener('click', (e) => {
        // Keep native summary from toggling open; we handle share ourselves.
        if (e.target === el || el.contains(e.target)) {
          e.preventDefault();
        }
      });
    }

    el.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      try {
        const result = await shareProduct({ url, title });
        if (result === 'copied') {
          el.classList.add('is-copied');
          showShareToast('Link copied');
          clearTimeout(el._shareTimer);
          el._shareTimer = setTimeout(() => el.classList.remove('is-copied'), 1800);
        }
      } catch (_) {
        window.prompt('Copy link', url);
      }
    });
  });
}

function initShopRailAdSetLinks(root = document) {
  root.querySelectorAll('.styloria-shop-rail__label').forEach((el) => {
    if ((el.textContent || '').trim() !== 'Ad Set') return;
    const link = el.closest('a.styloria-shop-rail__link');
    if (link) link.setAttribute('href', '/collections/ad-set');
  });
}

function initAll(root = document) {
  initGalleries(root);
  initShareButtons(root);
  initPdpShareButtons(root);
  initShopRailAdSetLinks(root);
}

document.addEventListener('DOMContentLoaded', () => initAll());

// Re-bind after Shopify facet / section AJAX refreshes
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
document.addEventListener('shopify:section:reorder', () => initAll());

const _shareObserver = new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (![...m.addedNodes].some((n) => n.nodeType === 1)) continue;
    initShareButtons(document);
    initPdpShareButtons(document);
    break;
  }
});
_shareObserver.observe(document.documentElement, { childList: true, subtree: true });

export { initGalleries, initShareButtons, initPdpShareButtons, initShopRailAdSetLinks };
